import { SubSink } from 'subsink';
import { ModalOtrosProductosDto } from './../../../feature/monitoreo/data/ModalOtrosProductosDto';
import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SubjectsService } from '../../../core/services/subjects.service';

@Component({
  selector: 'app-tabla-otros-productos',
  templateUrl: './tabla-otros-productos.component.html',
  styleUrls: ['./tabla-otros-productos.component.css']
})
export class TablaOtrosProductosComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  public subs = new SubSink();

  public dataModal: ModalOtrosProductosDto[] = [];

  public displayedColumns: string[] = [
    'empresa',
    'grupo',
    'recarga',
    'factura'
  ];

  public columns: string[];
  public dataSource: MatTableDataSource<ModalOtrosProductosDto>;

  constructor(
    private readonly subjectServices: SubjectsService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.paginationDataTable();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public paginationDataTable(): void {
    this.subs.add(this.subjectServices.informacionModalOtrosProductosGet.subscribe({
      next: (data) => {

        this.dataModal = data;
        this.dataSource = new MatTableDataSource(this.dataModal);
        this.cdr.markForCheck();
      }
    }));

  }

  public applyFilter(event: Event): void {

    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filter = filterValue.trim().toLowerCase();

    this.firstPage();

  }


  public firstPage(): void {
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
